import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {AWSPollyVoiceData} from '../../services/AWS_PollyVoiceData.Service';
import {UtilityService} from '../../services/utility.service';
import {Papa} from 'ngx-papaparse';
import {AWSPollyFile} from '../../models/AWS_Polly_TTS_File';



@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './polly-prompt-create-dialog.component.html',
    styleUrls: ['./polly-prompt-create-dialog.component.scss']
})

export class PollyPromptCreateDialogComponent implements OnDestroy, OnInit {
    @ViewChild('tabGroup') tabGroup;
    fileName: string;
    ttsForm: any;
    pollyLanguages: any[];
    pollyVoices: any[];
    pollyProcessList: AWSPollyFile[] = [];
    saveDisabled: boolean;
    filteredVoices: any;
    ttsSound: HTMLAudioElement;
    isDefault: boolean;
    fileLoadCount = 0;
    wordCount = 0;

    private ttsFile: string;
    private ttsMessage: string;
    private ttsFileName: any;
    private ttsVoice: any;
    private ttsLanguage: any;


    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<PollyPromptCreateDialogComponent>,
        private _pollyVData: AWSPollyVoiceData,
        private _utility: UtilityService,
        private papa: Papa,
        @Inject(MAT_DIALOG_DATA) public data: CreatePollyPromptDialogModel
    ) {
        this.pollyLanguages = [];
        this.pollyVoices = [];
    }

    ngOnInit(): void {
        this.saveDisabled = true;
        this.isDefault = false;
        this.ttsMessage = this.data.ttsMessage;
        if (this.data.fileName != null) {
             this.ttsFileName = this.data.fileName;
        }
        else {
            this.ttsFileName = '';
        }
        this.ttsLanguage = '';
        this.ttsVoice = '';
        this.ttsSound = new Audio();
        this.ttsForm = this.fb.group({
            isDefaultVoice: false,
            ttsMessage: [this.ttsMessage],
            ttsFileName: [this.ttsFileName],
            ttsVoice: [this.ttsVoice, Validators.required],
            ttsLanguage: [this.ttsLanguage, Validators.required],
            filesToUpload: new FormControl()
        });
        if (this.data.filePath !== '/') {
            this.data.filePath = this.data.filePath + '/';
        }

        this._pollyVData.getVoices().subscribe({
            next: (voices) => {
                this.setVoiceOptions(voices);
                this.pollyLanguages = this._pollyVData.getLanguages();
                let defaultVoice = null;
                const prefferedVoiceId = this._utility.getLocalStorageItem('defaultTTSVoiceId')
                if (this.data.ttsVoice != null && this.data.ttsVoice !== '') {
                    defaultVoice = this.pollyVoices.find(voice => voice.voiceId === this.data.ttsVoice);
                }
                if (defaultVoice == null) {
                    defaultVoice = this.pollyVoices.find(voice => voice.voiceId === prefferedVoiceId);
                }
                if (defaultVoice) {
                    this.isDefault = (defaultVoice.voiceId === prefferedVoiceId)
                    this.languageChange(defaultVoice.languageCode);
                    this.ttsForm.controls.isDefaultVoice.setValue(this.isDefault);
                    this.ttsForm.controls.ttsVoice.setValue(defaultVoice);
                    this.ttsForm.controls.ttsLanguage.setValue(defaultVoice.languageCode);
                }
            },
            error: (error) => {
                console.log('Error: ', error);
            }
        });


    }

    setVoiceOptions(voices){
        const options: any[] = [];
        voices.forEach(voice => {
            // Create an option for each supported engine
            voice.supportedEngines.forEach(engine => {

                let voiceId = voice.id
                let name = voice.name
                switch (engine) {
                    case 'neural': {
                        voiceId = `${voice.id}-${engine}`
                        name = voice.name
                        break;
                    }
                    case 'standard': {
                        voiceId = `${voice.id}`
                        name = voice.name + ' (Standard)'
                        break;
                    }
                    case 'generative': {
                        voiceId = `${voice.id}-${engine}`
                        name = voice.name + ' (AI)'
                        break;
                    }
                    case 'long-form': {
                        voiceId = `${voice.id}-${engine}`
                        name = voice.name + ' (AI-long)'
                        break;
                    }
                }

                options.push({
                    name,
                    languageCode: voice.languageCode,
                    languageName: voice.languageName,
                    voiceId, // Combined key as specified
                    id: voice.id,
                    gender: voice.gender,
                    engine: engine
                });
            });
        });

        this.pollyVoices = options;
    }


    ngOnDestroy(): void {
        this.ttsSound.pause();
    }
    onSave(): void
    {
        this.ttsSound.pause();
        const formVoice = this.ttsForm.get('ttsVoice').value;
        if (this.tabGroup.selectedIndex === 0) {
            let fileName = this.ttsForm.get('ttsFileName').value;
            if (fileName.substr(fileName.length - 4) !== '.wav') {
                fileName = fileName + '.wav';
            }
            const singlePolly = new AWSPollyFile();
            singlePolly.voice = formVoice;
            singlePolly.message = this.ttsForm.get('ttsMessage').value;
            singlePolly.file = this.ttsFile;
            singlePolly.filePath = this.data.filePath + fileName;
            this.pollyProcessList.push(singlePolly);
        }
        else {
            for (const batchFile of this.pollyProcessList)
            {
                if (batchFile.voice?.voiceId === '')
                {
                    batchFile.voice = formVoice;
                }
            }

        }
        this.saveDefaultVoice();
        this.dialogRef.close(this.pollyProcessList);
    }

    languageChange(langSelected: any): void {
        this.ttsSound.pause();
        this.ttsFile = '';
        this.filteredVoices = this.pollyVoices.filter(voice => voice.languageCode === langSelected);
        this.ttsForm.controls.ttsVoice.setValue(null);
    }

    playPolly(): void {
        this.ttsSound.pause();
        const formdata = this.ttsForm.getRawValue();
        let useVoice = formdata.ttsVoice;
        if (this.tabGroup.selectedIndex === 1) {
            if (typeof(this.pollyProcessList[0].voice.voiceId) !== 'undefined' && this.pollyProcessList[0].voice.voiceId !== ''){
                useVoice = this.pollyVoices.find(voice => voice.voiceId === this.pollyProcessList[0].voice.voiceId);
            }
            this._pollyVData.pollySynthesis(useVoice, this.pollyProcessList[0].message).then((response) => {
                this.ttsFile = response.ttsFile.file;
                this.playSound();
            });
        }
        else {
            this._pollyVData.pollySynthesis(useVoice, formdata.ttsMessage).then((response) => {
                this.ttsFile = response.ttsFile.file;
                this.playSound();
            });
        }
    }

    playSound(): void
    {
        this.ttsSound = new Audio('data:audio/wav;base64,' + this.ttsFile);
        this.ttsSound.play().then();
    }


    onDismiss(): void {
        this.ttsSound.pause();
        this.dialogRef.close();

    }


    messageChange(): void {
        this.ttsSound.pause();
        this.ttsFile = '';
    }

    saveDefaultVoice(): void {
        if (this.isDefault){
            this._utility.setLocalStorageItem('defaultTTSVoiceId', this.ttsForm.get('ttsVoice').value.voiceId);
        }
        else{
            this._utility.removeLocalStorageItem('defaultTTSVoiceId');
        }
    }


    handleCSVFile(csvSelectEvent: any): void {
        this.pollyProcessList = [];
        for (const file of csvSelectEvent.target.files) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (): void => {
                const csvTemplateString = atob((reader.result as string).split(',')[1]);
                const papaConfig = {
                    header: true,
                    step: (result): void => {
                        const singlePolly = new AWSPollyFile();
                        if (result.data.voiceId !== '')
                        {
                            singlePolly.voice = this.pollyVoices.find(voice => voice.voiceId === result.data.voiceId);
                        }
                        singlePolly.message = result.data.promptMessage;
                        singlePolly.filePath = result.data.filePath;
                        singlePolly.filePath = singlePolly.filePath.replace('\\', '/');
                        if (singlePolly.filePath.length > 0 && singlePolly.filePath.substr(0, 1) !== '/')
                        {
                            singlePolly.filePath = '/' + singlePolly.filePath;
                        }

                        this.pollyProcessList.push(singlePolly);
                        this.wordCount = this.wordCount + ((result.data.promptMessage.match(/ /g) || []).length) + 1;
                        this.fileLoadCount = this.fileLoadCount + 1;
                    },
                    complete: (result): void => {
                        this.saveDisabled = false;
                    },
                    skipEmptyLines: true,
                };
                this.papa.parse(csvTemplateString, papaConfig);
            };
            reader.onerror = (error): void => {
                console.log('Error: ', error);
            };
        }
    }

    voiceChange($event: any) {

    }
}


export class CreatePollyPromptDialogModel {

    constructor(
        public filePath: string,
        public ttsMessage: string,
        public ttsVoice: string,
        public fileName: string,
    )
    {

    }
}


